<template>
  <div class="select-box" v-clickoutside="handleClickOut">
    <div class="select-content-box" @click.stop="handleClickSelectBox" >
      <input type="text" readonly placeholder="请选择" v-model="currentValue">
      <i :class="['iconshangla', 'iconfont', isShow ? 'unfold' : 'pack']" ></i>
    </div>
    <div class="select-option-box" v-show="isShow" v-if="type === 'radio'">
      <ul>
        <li :class="['option-item', item === currentValue ? 'active' : '' ]" @click.stop="handleClickRadioItem(item)" v-for="(item, index) in data" :key="index">{{item}}</li>
      </ul>
    </div>
    <div class="select-option-box" v-show="isShow" v-else-if="type === 'check'">
      <ul>
        <li :class="['option-item', valueList.includes(item) ? 'active' : '' ]" @click.stop="handleClickCheckItem(item)" v-for="(item, index) in data" :key="index">
          <span>{{item}}</span>
          <i :class="['iconfont', valueList.includes(item) ? 'iconxuanzhong' : 'iconweixuanzhong']"></i>
        </li>
      </ul>
    </div>
    <div class="select-option-box" v-show="isShow" v-else-if="type === 'tags'">
      <ul class="tag-box">
        <li :class="[valueList.includes(item) ? 'active' : '' ]" @click.stop="handleClickCheckItem(item)" v-for="(item, index) in data" :key="index">
          <span>{{item}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import clickoutside from "../../../assets/js/clickoutside"
  export default {
    name: "custom-select",
    props: {
      data:{
        type: Array,
        default: () => []
      },
      type: {
        type: String,
        default: 'tags'
      },
      value:{
        type: [String, Array, Object]
      }
    },
    model:{
      prop: 'value',
      event: 'change'
    },
    data(){
      return {
        isShow: false,
        currentValue: "",
        valueList: []
      }
    },
    methods: {
      handleClickSelectBox(){
        this.isShow = !this.isShow
      },
      //单选操作
      handleClickRadioItem(value){
        this.currentValue = value
        this.$emit("change",value)
        this.isShow = false
      },
      //多选非标签
      handleClickCheckItem(value){
        if(this.valueList.includes(value)){
          this.valueList = this.valueList.filter(item => item != value)
        }else {
          this.valueList.push(value)
        }
        this.currentValue = this.valueList.join('，');
        this.$emit("change", this.valueList)
      },
      handleClickOut($event){
        this.isShow = false
      }
    },
    mounted() {
      if(typeof this.value == 'string'){
        this.currentValue = this.value
      }else{
        this.currentValue = this.value.join('，')
        this.valueList = this.value
      }
      // this.currentValue = typeof this.value == "string" ? this.value : this.value.join('，')
    },
    directives: {
      clickoutside
    }

  }
</script>

<style scoped lang="scss">
.select-box{
  width: 100%;
  position: relative;
  .select-content-box{
    width: 327px;
    height: 40px;
    background: #313744;
    border-radius: 6px;
    padding: 10px 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    &:hover{
      box-shadow: 0px 0px 6px 0px inset rgba(134, 161, 175, 0.4);
    }
    &>input{
      flex:1;
      width: 100%;
      background-color: #313744;
      border: none;
      outline: none;
      cursor: pointer;
      color: #FFFFFF;
      &::placeholder{
        color: rgba(255, 255, 255, 0.25);
      }
    }
    .iconfont{
      color: #FFFFFF;
      opacity: 0.2;
      transition: all 0.2s linear;
      transform: rotate(180deg);
    }
    .pack{
      transform: rotate(180deg);
    }
    .unfold{
      transform: rotate(0deg);
    }
  }
  .select-option-box{
    position: absolute;
    top: 45px;
    right: 0;
    left: 0;
    max-height: 164px;
    background: #313744;
    box-shadow: 0px 2px 12px 0px #202329;
    border-radius: 6px;
    z-index: 4;
    padding: 6px 0;
    overflow-y: auto;
    &::-webkit-scrollbar{
      display: none;
    }
    .option-item{
      height: 38px;
      padding:0 16px;
      box-sizing: border-box;
      text-align: left;
      line-height: 38px;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      &.active{
        background: #485063;
      }
      &:hover{
        background: #485063;
      }

    }
    .tag-box{
      display: flex;
      padding: 20px 5px 20px 19px;
      justify-content: flex-start;
      flex-wrap: wrap;
      list-style: none;
      & > li{
        border-radius: 15px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        padding: 8px 14px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        box-sizing: border-box;
        cursor: pointer;
        margin-bottom: 12px;
        margin-right: 12px;
        &.active{
          background: #FFFFFF;
          border-radius: 15px;
          color: #313744;
        }
      }
    }
  }
}
</style>
